document.addEventListener('turbolinks:load', function () {
  const menuButton = document.getElementById('menu-button');
  const closeButton = document.getElementById('close-menu-button');
  const mobileMenu = document.getElementById('mobile-menu');
  const blurredOverlay = document.getElementById('blurred-overlay');
  const focusableElements = mobileMenu.querySelectorAll('a, button');

  // Function to toggle the menu
  const toggleMenu = () => {
    const isMenuOpen = !mobileMenu.classList.contains('translate-x-full');

    if (isMenuOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  };

  // Function to open menu
  const openMenu = () => {
    mobileMenu.classList.remove('translate-x-full');
    blurredOverlay.classList.remove('hidden');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuButton.setAttribute('aria-expanded', 'true');
    focusableElements.forEach(el => el.removeAttribute('tabindex'));

    // Move focus to the first menu item
    focusableElements[0].focus();

    // Prevent focus from leaving menu
    document.addEventListener('keydown', trapFocus);
  };

  // Function to close menu
  const closeMenu = () => {
    mobileMenu.classList.add('translate-x-full');
    blurredOverlay.classList.add('hidden');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuButton.setAttribute('aria-expanded', 'false');
    focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));

    // Return focus to the menu button
    menuButton.focus();

    // Remove focus trap event listener
    document.removeEventListener('keydown', trapFocus);
  };

  // Initialize: menu starts closed so its focusable children must not be reachable
  focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));

  // Function to trap focus inside the menu
  const trapFocus = (event) => {
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
      if (event.shiftKey && document.activeElement === firstFocusable) {
        event.preventDefault();
        lastFocusable.focus();
      } else if (!event.shiftKey && document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  };

  // Handle menu button click (toggle functionality)
  if (menuButton) {
    menuButton.addEventListener('click', toggleMenu);
    menuButton.setAttribute('aria-expanded', 'false');
  }

  // Handle close button and overlay click
  if (closeButton) closeButton.addEventListener('click', closeMenu);
  if (blurredOverlay) blurredOverlay.addEventListener('click', closeMenu);

  // Close on Escape key
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !mobileMenu.classList.contains('translate-x-full')) {
      closeMenu();
    }
  });

  // Handle menu links closing the menu
  document.addEventListener('click', (event) => {
    const clickedElement = event.target.closest('a');
    if (!clickedElement) return;

    const isMakeABidButton = clickedElement.textContent.trim() === 'Make a Bid';
    const isMenuLink = clickedElement.closest('#mobile-menu');

    if (isMakeABidButton || isMenuLink) {
      const href = clickedElement.getAttribute('href');

      if (href === '#' || href === '' || href === null) {
        event.preventDefault();
      }

      if (!mobileMenu.classList.contains('translate-x-full')) {
        closeMenu();
      }
    }
  });
});
